import { Hero } from './components/Hero'
import { Features } from './components/Features'
import { HowItWorks } from './components/HowItWorks'
import { Tools } from './components/Tools'
import { GettingStarted } from './components/GettingStarted'
import { Footer } from './components/Footer'

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Hero />
      <Features />
      <HowItWorks />
      <Tools />
      <GettingStarted />
      <Footer />
    </div>
  )
}

export default App
